import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=9804fed2&scoped=true&"
import script from "./Notfound.vue?vue&type=script&lang=js&"
export * from "./Notfound.vue?vue&type=script&lang=js&"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=9804fed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804fed2",
  null
  
)

export default component.exports